import { Link, useNavigate } from 'react-router-dom';
import MetricsBar from '../MetricsBar.jsx';
import { useClientData } from '../ClientLayout.jsx';
import { statusDisplayLabel } from '../../lib/matterPipeline.js';
import { isPaidStatus } from '../../lib/paidBeforeAssignment.js';
import { debtorDisplayName } from '../../lib/debtorIdentity.js';
import { formatMatterMoney } from '../../lib/matterCurrency.js';

export default function ClientHomePage() {
  const navigate = useNavigate();
  const { matters, notice, openMatter } = useClientData();

  const recent = matters.slice(0, 5);
  const openCount = matters.filter((m) => !isPaidStatus(m.Status)).length;

  return (
    <div className="client-page">
      <div className="section-head">
        <div>
          <h1>Home</h1>
          <p>
            Pipeline KPIs across {matters.length} demand{matters.length === 1 ? '' : 's'} ·{' '}
            {openCount} open.
          </p>
        </div>
      </div>

      {notice ? <p className="inline-notice">{notice}</p> : null}

      <MetricsBar
        matters={matters}
        activeStage="ALL"
        onStageSelect={(stage) => {
          if (stage && stage !== 'ALL') {
            navigate(`/client/demands/kanban?stage=${encodeURIComponent(stage)}`);
          } else {
            navigate('/client/demands');
          }
        }}
      />

      <div className="home-panels">
        <section className="home-panel">
          <div className="home-panel-head">
            <h2>Recent demands</h2>
            <Link className="text-link strong" to="/client/demands">
              Open list →
            </Link>
          </div>
          {recent.length ? (
            <ul className="settings-list">
              {recent.map((m) => (
                <li key={m.ROWID} className="settings-list-row">
                  <button type="button" className="home-matter-link" onClick={() => openMatter(m)}>
                    <strong>{debtorDisplayName(m)}</strong>
                    <span className="muted-line">
                      {statusDisplayLabel(m.Status)} ·{' '}
                      {formatMatterMoney(m.Amount_Owed, m)}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p className="settings-sublead">No demands yet. Create one to get started.</p>
          )}
        </section>

        <section className="home-panel">
          <div className="home-panel-head">
            <h2>Quick links</h2>
          </div>
          <div className="home-quick-links">
            <Link to="/client/demands">Demands list</Link>
            <Link to="/client/demands/kanban">Demands kanban</Link>
            <Link to="/client/debtors">Debtor records</Link>
            <Link to="/client/messages">Messages</Link>
            <Link to="/client/reports">Reports</Link>
            <Link to="/client/guides">Guides · terms</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
